import sanitizeHtml from 'sanitize-html';

const htmlSanitizer = (html: string) =>
	sanitizeHtml(html, {
		allowedTags: [
			'div',
			'p',
			'em',
			'strong',
			'iframe',
			'br',
			'ul',
			'ol',
			'li',
			'a',
			'table',
			'tbody',
			'td',
			'tr',
			'img',
			'code',
			'pre',
			'i',
			'figure',
			'oembed',
			'h1',
			'h2',
			'h3',
			'h4',
			'h5',
			'h6',
		],
		allowedAttributes: {
			iframe: ['src'],
			a: ['href', 'target', 'rel'],
			div: ['class', 'onclick'],
			img: ['src', 'width', 'style', 'alt'],
			code: ['class'],
			pre: ['class'],
		},
		transformTags: {
			a: sanitizeHtml.simpleTransform('a', { target: '_blank', rel: 'noopener' }),
		},
		allowedIframeHostnames: ['www.youtube.com', 'player.vimeo.com'],
	});

export default htmlSanitizer;
